module.exports = __webpack_public_path__ + "follow.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/follow.png
// module id = 2123
// module chunks = 13